"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { useDialogMode } from "./DialogContext.js";
const DialogClose_DialogClose = /*#__PURE__*/ forwardRef(function({ className, buttonClassName, slots, 'aria-label': ariaLabel, ...props }, ref) {
    const mode = useDialogMode();
    const defaultAriaLabel = 'drawer' === mode ? 'Close drawer' : 'Close dialog';
    const classes = cn(className, buttonClassName, slots?.close);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Close, {
        ref: ref,
        className: classes,
        "aria-label": ariaLabel ?? defaultAriaLabel,
        ...props
    });
    return /*#__PURE__*/ jsx(Dialog.Close, {
        ref: ref,
        className: classes,
        "aria-label": ariaLabel ?? defaultAriaLabel,
        ...props
    });
});
export { DialogClose_DialogClose as DialogClose };
